{
  "name": "kekeno-questionnaire",
  "version": "1.33.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "test:ci": "ng test --watch=false --browsers=ChromeHeadless",
    "lint": "tsc --noEmit && eslint . --quiet --fix",
    "format": "prettier . --write",
    "eslint-origin": "eslint --max-warnings 10 --no-error-on-unmatched-pattern",
    "stylelint": "npx stylelint \"**/*.scss\"",
    "webapp:dev:testing": "ng serve --configuration testing"
  },
  "private": true,
  "engines": {
    "node": "^22.22.3 || ^24.15.0 || >=26.0.0"
  },
  "dependencies": {
    "@angular/animations": "^22.0.5",
    "@angular/cdk": "^22.0.3",
    "@angular/common": "^22.0.5",
    "@angular/compiler": "^22.0.5",
    "@angular/core": "^22.0.5",
    "@angular/forms": "^22.0.5",
    "@angular/material": "^22.0.3",
    "@angular/platform-browser": "^22.0.5",
    "@angular/platform-browser-dynamic": "^22.0.5",
    "@angular/router": "^22.0.5",
    "@auth0/angular-jwt": "^5.2.0",
    "@types/file-saver": "^2.0.7",
    "chart.js": "^4.4.0",
    "chartjs-plugin-datalabels": "^2.2.0",
    "file-saver": "^2.0.5",
    "firebase": "^12.15.0",
    "lodash": "^4.17.21",
    "material-icons": "^1.13.12",
    "material-symbols": "^0.45.6",
    "ngx-editor": "^18.0.0",
    "ngx-filesaver": "^21.0.0",
    "rxjs": "~7.8.0",
    "tailwind-scrollbar": "^3.1.0",
    "tslib": "^2.3.0",
    "uuid": "^14.0.1",
    "zone.js": "~0.16.2"
  },
  "devDependencies": {
    "@angular-eslint/eslint-plugin-template": "^22.0.0",
    "@angular-eslint/template-parser": "^22.0.0",
    "@angular/build": "^22.0.5",
    "@angular/cli": "~22.0.5",
    "@angular/compiler-cli": "^22.0.5",
    "@eslint/js": "^10.0.1",
    "@playwright/test": "^1.61.1",
    "@types/jasmine": "~6.0.0",
    "@types/lodash": "^4.14.200",
    "@types/node": "^26.1.0",
    "@typescript-eslint/eslint-plugin": "^8.63.0",
    "@typescript-eslint/parser": "^8.63.0",
    "@typescript-eslint/types": "^8.63.0",
    "@typescript-eslint/utils": "^8.63.0",
    "angular-eslint": "^22.0.0",
    "autoprefixer": "^10.5.2",
    "daisyui": "^3.9.4",
    "eslint": "^10.6.0",
    "eslint-config-prettier": "^10.1.8",
    "eslint-plugin-prettier": "^5.5.6",
    "globals": "^17.7.0",
    "husky": "^8.0.3",
    "jasmine-core": "~6.3.0",
    "jiti": "^2.6.1",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.2.0",
    "otpauth": "^9.5.1",
    "postcss": "^8.5.16",
    "prettier": "^3.9.4",
    "stylelint": "^17.14.0",
    "stylelint-config-standard-scss": "^17.0.0",
    "stylelint-scss": "^7.2.0",
    "tailwindcss": "^3.4.19",
    "typescript": "~6.0.3",
    "typescript-eslint": "^8.63.0"
  },
  "husky": {
    "hooks": {
      "pre-commit": "npm lint",
      "pre-push": "npm format"
    }
  }
}
